<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2>
          <template v-if="isCreateNewEmploymentTitle">Tilføj ny ansættelse</template>
          <template v-else>Er det til vikarer?</template>
        </h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')"><span
          class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <div class="d-input-group" v-if="isCreateNewEmploymentTitle">
          <label class="d-label">Titel</label>
          <input type="text" class="d-input" v-model="title" ref="title_input">
        </div>
        <label class="d-label" style="margin: 0 1rem;">Skal personale med denne ansættelse inkluderes i
          vikarlønindberetningen?</label>
        <div class="d-input-group d-input-group--toggler"
             :class="{'d-input-group--toggler--active': isManualSalary}"
             @click.stop="$emit('setIsManualSalary', !isManualSalary)">
          <label class="d-label">Skal indberettes som vikarløn
          </label>
          <AppToggle :allowChanges="false" :propOn="isManualSalary"></AppToggle>
        </div>
      </div>
      <div class="d-modal__buttons">
        <div>
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit do-bttn--submit--disabled" v-if="!isValid">
            Tilføj til {{ selectedUsers.length }} {{ selectedUsers.length === 1 ? 'person' : 'personer' }}
          </button>
          <button class="do-bttn do-bttn--submit" @click="onSubmit"
                  v-else>
            Tilføj til {{ selectedUsers.length }} {{ selectedUsers.length === 1 ? 'person' : 'personer' }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import AppToggle from '../../common/AppToggle.vue'
import ModalConfirmation from '../../Modals/ModalConfirmation.vue'

export default {
  components: {ModalConfirmation, AppToggle, DModal},
  props: {
    isCreateNewEmploymentTitle: {
      type: Boolean,
      default: false
    },
    isManualSalary: {
      type: Boolean,
      default: false
    },
    selectedUsers: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      title: '',
      isDeleteConfirm: false,
      isDeleting: false
    }
  },
  computed: {
    isValid () {
      return this.isCreateNewEmploymentTitle ? this.title.length > 0 : true
    }
  },
  methods: {
    onSubmit () {
      if (this.isCreateNewEmploymentTitle) {
        this.$emit('save', this.title)
      } else {
        this.$emit('save')
      }
      this.$emit('close')
    }
  },
  mounted () {
    if (this.isCreateNewEmploymentTitle) {
      this.$refs.title_input.focus()
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 2rem;
}

</style>



// WEBPACK FOOTER //
// SalarySettingsCreateEmploymentType.vue?0b56c1ca